import { render, staticRenderFns } from "./ContactAttributesDialog.vue?vue&type=template&id=0725acd0&scoped=true&"
import script from "./ContactAttributesDialog.vue?vue&type=script&lang=js&"
export * from "./ContactAttributesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContactAttributesDialog.vue?vue&type=style&index=0&id=0725acd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0725acd0",
  null
  
)

export default component.exports